import React from 'react';
import { Navigate } from 'react-router-dom';
import { Col } from 'reactstrap';

import { RequestForm } from './form';

export function Request() {
  if (sessionStorage.getItem('vapp-terms') === null) {
    return <Navigate to="/compliance" />;
  }
  return (
    <main id="main" className="p-3">
      <Col className="mx-auto" xl={4} lg={4} md={5} sm={6}>
        <RequestForm />
      </Col>
    </main>
  );
}
